import React, { useEffect, useState } from 'react';

import Navbar from '../components/TopNav';
import Footer from '../components/Footer';

import { NftTokenService } from '../services/NftTokenService';
import { getNetworkName } from '../utils';
import InfiniteScroll from 'react-infinite-scroll-component';
import { checkIsWalletConnected, checkNetwork } from '../web3Utils';
import { Link } from 'react-router-dom';
import ListNftModal from '../components/marketPlace/ListINftModal';

const Inventory = () => {
  
  const [nftList, setNftList] = useState([]);
  const [nftBalance, setNftBalance] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [isWalletConnected, setIsWalletConnected] = useState(false);
  const [isCorrectNetwork, setIsCorrectNetwork] = useState(false);

  const [tokenIdForListing, setTokenIdForListing] = useState('');


  useEffect(()=> {
    init();
  },[]);

  const init = async () => {
    checkIsWalletConnected().then((isConnected) => setIsWalletConnected(isConnected))
    checkNetwork().then((isNetworkId) => setIsCorrectNetwork(isNetworkId))

    setIsLoading(true);
    try {
      const nftTokenService = new NftTokenService();
      const nftBalance = await nftTokenService.balanceOf();
      const nfts = await nftTokenService.getAll({});

      setNftBalance( nftBalance );
      setNftList( nfts );
      setIsLoading(false);
    } catch(err) {
      console.log('err', err);
      setIsLoading(false);
    }
  }

  const loadMoreNfts = async () => {
    const nftTokenService = new NftTokenService();
    const nfts = await nftTokenService.getAll({ skip: nftList.length });
    setNftList([ ...nftList, ...nfts ]);
  }

  const parseType = (attrs) => {
    if(!attrs) {
      return '-';
    }
    
    const typeAttr = attrs.find((attr) => attr.trait_type === 'type' );
    return typeAttr ? typeAttr.value.replace(/_/g, " ") : '-';
  }

  return (
    <div className="row no-gutters accumulation">
      <Navbar />
      <ListNftModal toggle={!!tokenIdForListing} onCloseModal={() => setTokenIdForListing('')}  tokenId={tokenIdForListing} />
      <div className="col-12 main pb-5">
        <h5 className="title">YOUR INVENTORY</h5>
          {
            isLoading ?
              <div className="my-5">
                Loading, please wait...
              </div>
            : !isWalletConnected ?
              <div className="my-5">
                Please, connect your <b>wallet</b> to show your NFTs here!
              </div>
            : !isCorrectNetwork ? 
              <div className="my-5">
                Switch to {getNetworkName(process.env.REACT_APP_MAIN_NETWORK_ID)} Network.
              </div>
            : 
              <>
                <div className="table-responsive" id="nft-inventory-list">
                  <InfiniteScroll
                      scrollableTarget="nft-inventory-list"
                      dataLength={nftList.length} //This is important field to render the next data
                      next={() => loadMoreNfts()}
                      hasMore={ nftList.length < nftBalance }
                      loader= {
                        <div className="w-50 mx-auto p-3 inventory-loader" tabIndex="0">
                          Loading...
                        </div>
                      }
                    >
                      <table className="table">
                        <thead>
                          <tr className="top-tr">
                            <th>Name</th>
                            <th>Category</th>
                            <th>Type</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {nftList.map(nft=> (
                            <tr className={'tr'}>
                              <td className={'td-left text-white'}>
                                <div className="d-flex">
                                  <img width={40} height={40} src={nft.image} />
                                  <span className="ml-2">
                                    {nft.name} <br /> ({nft.tokenId})
                                  </span>
                                </div>
                              </td>
                              <td class="text-white">{nft.category}</td>
                              <td className="text-white">
                                {parseType(nft.attributes)}
                              </td>
                              <td className="td-right text-white">
                                <button onClick={() => setTokenIdForListing(nft.tokenId)} className="btn buy">
                                  List Token
                                </button>
                              </td>
                            </tr>
                          ))} 
                        </tbody>
                      </table>
                      <div className="mobile-view">
                        {nftList.map(nft => (
                          <div className={'sec-box box'}>
                            <div className="py-3">
                            <p>{nft.name} ({nft.tokenId})</p>
                            <p>{nft.category}</p>
                            <p>
                              {parseType(nft.attributes)}
                            </p>
                            <p>
                              <button onClick={() => setTokenIdForListing(nft.tokenId)} className="btn buy">
                                List Token
                              </button>
                            </p>
                          </div>
                          </div>
                        ))}
                      </div>
                  </InfiniteScroll>
                </div>
              </>
          }
           <div className="my-5">
             Looking to swap your Binance Mystery Box NFT for a Monsters Clan NFT? Click <Link to="/binance-swap" >here</Link>!
           </div>
      </div>
      <Footer />
     </div>
  )
}

export default Inventory;